import React, { useContext } from "react";
import { ShopContext } from "../../context/ShopContext";
import imageMap from "../../components/assets/imageMap";
import whatsapp from "../assets/logo/whatsapp.png";
import { Link } from "react-router-dom";
import { formatPrice } from "../../utils/formatPrice";
import { CUSTOM_BLOUSE_PRICE } from "../../pages/CustomizeBlouse";

// "All Services" homepage grid for Tailoring: each tile is an image-based
// link into a submenu tab rather than an individual purchasable product -
// no Add to Cart, just title / starting price / WhatsApp enquiry.
const TILES = [
    { title: "Blouse Stitching", targetTab: "blouse", imageKey: "tailor_home_blouse" },
    { title: "Thanjavur Painting", targetTab: "art-handicraft", imageKey: "tailor_home_thanjavur" },
    { title: "Aari Work", targetTab: "aari", imageKey: "tailor_home_aari" },
    { title: "Alteration", targetTab: "alteration", imageKey: "tailor_home_alteration" },
    { title: "Saree Knot", targetTab: "saree-threading", imageKey: "tailor_home_saree_threading" },
    { title: "Saree Falls", targetTab: "saree-falls", imageKey: "tailor_home_saree_falls" },
    { title: "Half Saree Stitching", targetTab: "half-saree", imageKey: "tailor_home_half_saree" },
    { title: "Kids Dress", targetTab: "kids", imageKey: "tailor_home_kids" },
    { title: "Lehenga", targetTab: "lehenga", imageKey: "tailor_home_lehenga" },
];

// "Design Yours" (the pick-your-own-design blouse flow) isn't a real
// Firestore product, so it's added into the blouse tile's price list by
// hand - every other tile's starting price comes straight from its
// category's cheapest real product.
const startingPrice = (products, subCategory) => {
    const prices = products
        .filter((item) => item.subCategory === subCategory)
        .map((item) => (item.variants ? Math.min(...item.variants.map((v) => v.price)) : item.new_price))
        .filter((price) => price != null);
    if (subCategory === "blouse") {
        prices.push(CUSTOM_BLOUSE_PRICE);
    }
    return prices.length > 0 ? Math.min(...prices) : null;
};

const TailorServiceGrid = ({ onSelect }) => {
    const { all_product } = useContext(ShopContext);
    const tailoringProducts = all_product.filter((item) => item.category === "tailoring");

    return (
        <div className="shopcategory-items">
            {TILES.map((tile) => {
                const price = startingPrice(tailoringProducts, tile.targetTab);
                const whatsappMessage = encodeURIComponent(`Chat~${tile.title}`);
                return (
                    <div key={tile.targetTab} className="item">
                        <div className="item-link" style={{ cursor: "pointer" }} onClick={() => onSelect(tile.targetTab)}>
                            <img src={imageMap[tile.imageKey]} alt="" />
                        </div>
                        <p>{tile.title}</p>
                        <div className="item-prices-container">
                            {price != null && (
                                <div className="item-prices">
                                    <div className="item-price-new">Starting at {formatPrice(price)}</div>
                                </div>
                            )}
                            <Link to={"https://wa.me/14249778995?text=" + whatsappMessage}>
                                <img src={whatsapp} alt="Chat on Whatsapp" width="30px" height="" />
                            </Link>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TailorServiceGrid;
